import { useDataValue } from 'Simple/Data'

export default function useDataConfiguration(props) {
  let connection_id = useDataValue({
    context: 'connection',
    path: 'id',
    viewPath: props.viewPath,
  })
  return {
    variables: {
      connection_id,
    },
    requestPolicy: 'network-only',
  }
}
